module.exports = __webpack_public_path__ + "img/成都有哪些人才政策.462d4041.png";